<template>
  <v-layout row wrap justify-center align-center column v-if="profile">
    <v-flex xs12>
      <v-tooltip lazy right>
        <label slot="activator" for="image-upload-admin" style="cursor: pointer;">
          <v-avatar
            size="100px"
          >
            <img :src="profile.image" :alt="profile.family_name">
          </v-avatar>
        </label>
        <input hidden ref="image" @change="imageDialog = true" type="file" id="image-upload-admin" accept=".jpeg, .jpg, .png">
        <span>Change picture</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs12>
      <v-tooltip lazy bottom>
        <v-badge slot="activator" style="cursor: pointer;" @click.native="profileDialog = true">
          <v-icon slot="badge" dark small>edit</v-icon>
          <span class="display-1">{{profile.given_name}} {{profile.family_name}}</span>
        </v-badge>
        <span>Edit Profile</span>
      </v-tooltip>
    </v-flex>
    <v-flex>
      <small style="cursor: pointer;" @click="passwordDialog = true">Change Password</small>
    </v-flex>

    <v-dialog v-model="profileDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  label="Given Name"
                  v-model="givenName"
                  required
                  :error-messages="givenNameErrors"
                  @input="$v.givenName.$touch()"
                  @blur="$v.givenName.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Family Name"
                  v-model="familyName"
                  required
                  :error-messages="familyNameErrors"
                  @input="$v.familyName.$touch()"
                  @blur="$v.familyName.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Middle Name"
                  v-model="middleName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  label="Ext."
                  v-model="extName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md5>
                <v-menu
                  ref="menu"
                  lazy
                  :close-on-content-click="false"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Birthdate"
                    v-model="date"
                    prepend-icon="event"
                    readonly
                    required
                    :error-messages="dateErrors"
                    @input="$v.date.$touch()"
                    @blur="$v.date.$touch()"
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="date"
                    @change="save"  
                    :allowed-dates="allowedDates"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Address"
                  multi-line
                  rows="2"
                  v-model="address" 
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p class="subheading">Gender:</p>
                <v-radio-group v-model="gender" row>
                  <v-radio label="Male" :value="true" ></v-radio>
                  <v-radio label="Female" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Contact Number"
                  mask="###########"
                  v-model="contactNo"
                  :error-messages="contactNoErrors"
                  @input="$v.contactNo.$touch()"
                  @blur="$v.contactNo.$touch()"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <small>*indicates required field</small>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click="profileDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="editProfileDetails">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="passwordDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Change Password</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="password1"
                  label="Enter new password"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password2"
                  label="Re-Enter password"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click="passwordDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="changePassword">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row justify-center>
      <v-dialog v-model="imageDialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">Changing Image</v-card-title>
          <v-card-text>
            <p>Are you sure?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click="imageDialog = false" :disabled="loading">Close</v-btn>
            <v-btn 
              dark
              color="blue darken-1" 
              :loading="loading"
              :disabled="loading"
              @click="changeProfileImage"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </v-layout>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    givenName: {
      required
    },
    familyName: {
      required
    },
    contactNo: {
      required
    }
  },
  data(){
    return {
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      date: '',
      menu: false,
      address: '',
      contactNo: '',
      profile: null,
      imageDialog: false,
      profileDialog: false,
      loading: false,
      gender: true,
      passwordDialog: false,
      password1: '',
      password2: ''
    }
  },
  created(){
    this.getProfile()  
  },
  methods: {
    async changePassword(){
      if(this.password1 && this.password2){
        if(this.password1 === this.password2){
          try{
            this.$Progress.start()
            let res = await axios.post('/api/profile/changepassword', {
              password: this.password1
            }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})
            this.passwordDialog = false
            this.password1 = ''
            this.password2 = ''
            this.showSuccessMsg({ title: 'Success!', message: 'Password updated successfully!' })
            this.$Progress.finish()
          }catch(e){
            console.log(e)
            this.$Progress.fail()
          }
        } else {
          this.showErrorMsg({ title: 'Error!', message: 'Passwords do not match!' })
          this.$Progress.fail()
        }
      }
    },
    async getProfile(){
      let profile = await axios.get('/api/profile', { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` }})

      this.givenName = profile.data.given_name
      this.familyName = profile.data.family_name
      this.middleName = profile.data.middle_name
      this.extName = profile.data.ext_name
      this.date = profile.data.birthday
      this.address = profile.data.address
      this.contactNo = profile.data.contact_number
      this.gender = profile.data.isMale
      this.profile = profile.data
    },
    async changeProfileImage(){
      const data = new FormData()
      data.append('image', this.$refs.image.files[0])
      try{
        this.$Progress.start()
        this.loading = true
        let res = await axios.post('/api/profile/image/update', data, { 
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`,
            'Content-Type': 'multipart/form-data'
          }
        })
        this.showSuccessMsg({ title: 'Success!', message: 'Profile image updated successfully!' })
        this.$Progress.finish()
        this.getProfile()
        this.loading = false
        this.imageDialog = false
      }catch(e){
        console.log(e)
        this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.join(' ') })
        this.loading = false
        this.$Progress.fail()
      }
    },
    async editProfileDetails(){
      let { givenName, familyName, middleName, extName, address, contactNo, date, gender } = this

      if(!this.$v.$error){
        try{
          this.$Progress.start()
          await axios.post('/api/profile/update', {
            given_name: givenName,
            family_name: familyName,
            middle_name: middleName,
            ext_name: extName,
            birthday: date,
            address,
            contact_number: contactNo,
            isMale: gender
          }, { headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
          }})
          this.showSuccessMsg({ title: 'Success!', message: 'Profile details updated successfully!' })
          this.getProfile()
          this.$Progress.finish()
          this.profileDialog = false
        }catch(e){
          console.log(e)
          this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.join(' ') })
          this.$Progress.fail()
        }
      }
    },
    allowedDates(val){
      return new Date().toISOString().substr(0,10) >= val
    },
    save (date) {
      this.$refs.menu.save(date)
    },
  },
  computed: {
    dateErrors(){
      const errors = []
      if(!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Birthdate is required')
      return errors
    },
    givenNameErrors(){
      const errors = []
      if(!this.$v.givenName.$dirty) return errors
      !this.$v.givenName.required && errors.push('Given name is required')
      return errors
    },
    familyNameErrors(){
      const errors = []
      if(!this.$v.familyName.$dirty) return errors
      !this.$v.familyName.required && errors.push('Family name is required')
      return errors
    },
    contactNoErrors(){
      const errors = []
      if(!this.$v.contactNo.$dirty) return errors
      !this.$v.contactNo.required && errors.push('Contact number is required')
      return errors
    },
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Profile.vue